jQuery(document).ready(function($) {

    window.onscroll = function() {navSticky();};

    var header = document.getElementById('masthead');
    var body = document.getElementsByTagName('body')[0];
    var sticky = header.offsetTop + 100;

    function navSticky() {
        if (window.pageYOffset > sticky) {
            header.classList.add('is-sticky');
            body.classList.add('is-sticky');
        } else {
            header.classList.remove('is-sticky');
            body.classList.remove('is-sticky');
        }
    }

    var $loading = $('#ajax-loading').hide();

    $(document).ajaxStart(function() {
        $loading.show();
    }).ajaxStop(function() {
        $loading.hide();
    });

    // Close mobile menu - click the x icon.
    $('.close-drawer').on('click', function() {
        $('body').removeClass('mobile-toggled').removeClass('drawer-open');
    });

    //@see https://www.smartmenus.org/docs/
    $('.sm, .product-categories').smartmenus({
        showFunction: function($ul, complete) {
            $ul.show();
        },
        hideFunction: function($ul, complete) {
            $ul.hide();
        },
        showTimeout : 0,
        hideTimeout : 0,
    });

    function isVisible(element) {
        if (element.length > 0 && element.css('display') !== 'none') {
            return true;
        } else {
            return false;
        }
    }

    function goToTop() {
        var $goToTopEl = $('.back-to-top'),
            elementScrollSpeed = $goToTopEl.attr('data-speed'),
            elementScrollEasing = $goToTopEl.attr('data-easing');

        if (!elementScrollSpeed) {
            elementScrollSpeed = 700;
        }
        if (!elementScrollEasing) {
            elementScrollEasing = 'easeOutQuad';
        }

        $goToTopEl.click(function() {
            $('body,html').stop(true).animate({
                'scrollTop': 0,
            }, Number(elementScrollSpeed), elementScrollEasing);
            return false;
        });
    }

    function goToTopScroll() {
        var $goToTopEl = $('.back-to-top'),
            elementMobile = $goToTopEl.attr('data-mobile'),
            elementOffset = $goToTopEl.attr('data-offset');

        if (!elementOffset) {
            elementOffset = 250;
        }

        if (elementMobile !== 'true') {
            return true;
        }

        if ($(window).scrollTop() > Number(elementOffset)) {
            $goToTopEl.fadeIn();
        } else {
            $goToTopEl.fadeOut();
        }
    }

    goToTop();
    $(window).on('scroll', function () {
        goToTopScroll();
    });

    $('.js-dropdown-trigger').on('click', function() {
        var dropdown_id = $(this).data('id');
        var dropdown_content = $('#' + dropdown_id);

        if (dropdown_content.hasClass('is-active') || isVisible(dropdown_content)) {
            dropdown_content.hide().removeClass('is-active');
        } else {
            $('.js-dropdown-content').hide().removeClass('is-active');
            dropdown_content.show().addClass('is-active');
        }

        return false;
    });

    $('#js-menu-toggle').click(function(){
        $('.js-dropdown-content').hide().removeClass('is-active');
    });

    $('.js-dropdown-trigger').click(function(){
        $('#site-navigation').removeClass('is-toggled');
    });

    $('a.has-submenu').hover(function() {
        $('.js-dropdown-content').hide().removeClass('is-active');
    });

    $('.js-close').click(function() {
        $(this).parent().parent().hide().removeClass('is-active');
    });
});
